import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-toggle-switch',
  template: `
  <span *ngIf="!inlineTrackLabels" [ngClass]="labelActivetext.toLowerCase()=='active' && 'label-text' ">{{_CheckedStatus ? labelActivetext : labelInactivetext }}</span>
  <span [class.ml-2]="labelActivetext.length && !inlineTrackLabels" *ngIf="formcontrolname" >
  <label class="switch" [id]="id">
      <input #inp type="checkbox" [checked]="_CheckedStatus" (click)="emitValue($event)"  [formControlName]="formcontrolname"  [attr.disabled]="isDisable"  />
      <span class="slider round" [ngClass]="isDisable && 'disable' "></span>
  </label>
  </span>
  <span class="ml-2" *ngIf="!formcontrolname && inlineTrackLabels">
    <label class="switch switch-inline-track" [id]="id || null" [class.inline-checked]="_CheckedStatus">
      <input type="checkbox" [checked]="_CheckedStatus" [disabled]="isDisable" (click)="emitInlineClick($event)" />
      <span class="slider round slider-inline-track" [ngClass]="isDisable && 'disable'">
        <span class="inline-track-label inline-track-on">{{ labelActivetext }}</span>
        <span class="inline-track-label inline-track-off">{{ labelInactivetext }}</span>
      </span>
    </label>
  </span>
  <span  class="ml-2" *ngIf="!formcontrolname && !inlineTrackLabels">
  <label  class="switch" [id]="id">
      <input #inp type="checkbox" [checked]="_CheckedStatus" [disabled]="isDisable" (click)="emitValue($event)"   />
      <span class="slider round" [ngClass]="isDisable && 'disable' "></span>
  </label>
  </span>

  `,
  styleUrls: ['./switch.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class SwitchComponent implements OnChanges, OnInit {

  constructor(
    private _fb: FormGroupDirective,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._CheckedStatus = this.isChecked

    if (this.formcontrolname) {
      this._CheckedStatus = this._fb.control.get(this.formcontrolname).value
      this._fb.control.get(this.formcontrolname).valueChanges.subscribe((res) => {
        this._CheckedStatus = res
      })

      if (this.isDisable) this._fb.control.get(this.formcontrolname).disable()
      else this._fb.control.get(this.formcontrolname).enable()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    /* Only sync from parent when isChecked changes — avoids wiping inline toggle after click before parent/dialog updates */
    if (changes['isChecked']) {
      this._CheckedStatus = this.isChecked;
    }

    if (this.formcontrolname) {
      if (changes.isDisable) {
        if (this.isDisable) this._fb.control.get(this.formcontrolname).disable()
        else this._fb.control.get(this.formcontrolname).enable()
      }
    }
  }
  
  @Input() isChecked: boolean = false
  @Input() isDisable: boolean = false
  @Input('type') id: '' | 'secondary' | 'secondary-primary' | 'admin-primary' | 'labadmin-primary' = ''
  @Input() formcontrolname: string | null = null
  @Output() clicked = new EventEmitter()
  @Input() labelActivetext: string = ''
  @Input() labelInactivetext: string = ''
  /** Wide pill toggle with labels inside the track (checked = left label, unchecked = right label). */
  @Input() inlineTrackLabels = false
  _CheckedStatus: boolean = false
  //@ViewChild('inp') input
  //valueHolder : boolean = false


  emitValue(e: any) {
    this._CheckedStatus = e.target.checked;
    //this.valueHolder = this.isChecked
    //let x = this.input.nativeElement
    this.clicked.emit(e.target.checked);
  }

  /** Inline toggle: sync UI from _CheckedStatus so User/Group & Edit/View update immediately (CSS :checked can lag vs [checked]). */
  emitInlineClick(e: Event) {
    const input = e.target as HTMLInputElement;
    if (this.isDisable) {
      e.preventDefault();
      return;
    }
    this._CheckedStatus = input.checked;
    this.clicked.emit(input.checked);
    this.cdr.markForCheck();
  }
}
